import { useLocalization } from "@fluent/react";
import ReactMarkdown from "react-markdown";
import { Dialog } from "cerulean";
import { useInstitutionSettings } from "../../contexts/InstitutionSettingsContext";

type InternationalWireTemplateFormProps = {
  isOpen: boolean;
  onDismiss: () => void;
};

const InternationalWireRateDialog = ({
  isOpen,
  onDismiss,
}: InternationalWireTemplateFormProps) => {
  const { l10n } = useLocalization();
  // eslint-disable-next-line camelcase
  const { swift_fx_quote_disclosure } = useInstitutionSettings();

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={onDismiss}
      title={l10n.getString(
        "international-wire-rates-dialog-title"
      )}
    >
      <div className="fontColor--secondary">
        <ReactMarkdown>
          {/* eslint-disable-next-line camelcase */}
          {swift_fx_quote_disclosure || ""}
        </ReactMarkdown>
      </div>
    </Dialog>
  );
};

export default InternationalWireRateDialog;
